var map = {
	"./components/home/dashboard/widgets/ButtonWidget/view.vue": [
		"7a4b",
		"chunk-4281f99a"
	],
	"./components/home/dashboard/widgets/OneToOneAgreementsWidget/view.vue": [
		"a1da",
		"chunk-48c34b7a"
	],
	"./components/home/dashboard/widgets/OneToOneMeetingsWidget/view.vue": [
		"fa6a",
		"chunk-4b8a22df"
	],
	"./components/home/dashboard/widgets/TextWidget/view.vue": [
		"8b5a",
		"chunk-6fca0fb3"
	],
	"./components/home/dashboard/widgets/VQBCellWidget/view.vue": [
		"2f89",
		"chunk-1fb5fbd8"
	],
	"./components/home/dashboard/widgets/VQBChartWidget/charts/line/view.vue": [
		"7efe",
		"chunk-3a0de13c"
	],
	"./components/home/dashboard/widgets/VQBChartWidget/charts/pie/view.vue": [
		"3a1a",
		"chunk-4ef9cacb"
	],
	"./components/home/dashboard/widgets/VQBChartWidget/view.vue": [
		"9279",
		"chunk-854b0ad4"
	],
	"./components/home/dashboard/widgets/VQBTableWidget/view.vue": [
		"495b",
		"chunk-7d5cfc97"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3e79";
module.exports = webpackAsyncContext;